/**
 * Helpers for surfacing the Employee Identifier and Position consistently
 * across reports, exports, and dashboards.
 *
 * When a stored staff ID is available, display it. Otherwise fall back
 * to a stable derived label (`EMP-<first-8-of-uuid>`) so reports remain
 * readable without requiring every environment to have a staff_id column.
 */

const FALLBACK_PREFIX = 'EMP-';

/**
 * Format an Employee ID for display. Returns the trimmed staff_id when
 * present, otherwise a deterministic `EMP-XXXXXXXX` derived from the
 * user's UUID.
 */
export function formatEmployeeId(
  staffId: string | null | undefined,
  userId?: string | null,
): string {
  const trimmed = (staffId ?? '').trim();
  if (trimmed) return trimmed;
  if (!userId) return '';
  return FALLBACK_PREFIX + userId.substring(0, 8).toUpperCase();
}

/**
 * Format a Position for display. Returns the trimmed value when
 * present, otherwise a single em dash.
 */
export function formatPosition(position: string | null | undefined): string {
  const trimmed = (position ?? '').trim();
  return trimmed || '—';
}
